var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26758 3.875L12.184 0.958624L16.8015 5.57622L13.8852 8.49259L9.26758 3.875Z",
    fill: "#918CBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54123 4.60156L0.458984 12.6831L1.03648 16.7242L5.07692 17.3018L13.1592 9.2195L8.54123 4.60156Z",
    fill: "#918CBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNote);
export default __webpack_public_path__ + "static/media/edit-note.33061eccb6c01fb9278eb068018a76af.svg";
export { ForwardRef as ReactComponent };